<template>
  <div>
    <div class="header show-for-medium">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message">Your age pension</span>
        </div>
      </div>
    </div>

    <section>
      <div class="row">
        <div class="small-12 medium-4 columns">
          <label>Current value of other investments <help-icon message="This includes the combined total value of all investments, excluding super and your home. Examples include rental property, shares and cash management accounts."></help-icon></label>
        </div>

        <div class="medium-6 columns">
          <slider :property="inputs.OtherAssets" @update="actionOtherAssets({ value: $event.values[0], modifier: '' })"></slider>
        </div>

        <div class="small-12 medium-2 columns">
          <custom-input type="number" filter="currencyDisplay" :property="inputs.OtherAssets" @change="actionOtherAssets({ value: $event.target.value, modifier: '' })"></custom-input>
        </div>
      </div>

      <div class="row">
        <div class="small-12 columns inline-input">
          <label>Include government Age Pension in results? <span class="inline-help-icon"><help-icon message="Select yes if you’d like to include the Government Age Pension in your retirement income projection. This will be subject to eligibility."></help-icon></span></label>
          <checkbox name="include-age-pension" :items="yesNo" :selected="inputs.IncludeAgePension" @change="actionIncludeAgePension({ value: $event.value, modifier: '' })"></checkbox>
        </div>

        <div class="small-12 columns inline-input">
          <label>Do you expect to own your own home at retirement? <span class="inline-help-icon"><help-icon message="If you expect to own your own home or be paying off a mortgage at retirement select yes. If you expect to be renting select no."></help-icon></span></label>
          <checkbox name="home-owner" :items="yesNo" :selected="inputs.HomeOwner" @change="actionHomeOwner({ value: $event.value, modifier: '' })"></checkbox>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      yesNo: {
        yes: {
          value: true,
          text: 'Yes',
        },
        no: {
          value: false,
          text: 'No',
        },
      },
    };
  },
  computed: {
    ...mapState(['inputs']),
  },
  methods: {
    ...mapActions([
      'actionIncludeAgePension',
      'actionHomeOwner',
      'actionOtherAssets',
    ]),
  },
};
</script>
